<template>
    <div class="report" v-loading="loading" v-if="definition">
        <el-menu mode="horizontal" class="flex items-center px-30 h-60">
            <div class="flex gap items-center grow">
                <h2 class="title">{{ title }}</h2>
                <div class="grow">
                    <el-select
                        v-model="selectedReport"
                        placeholder="Select"
                        @change="navigateTo"
                    >
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="mr-4">
                <el-button
                    :disabled="exporting"
                    v-loading="exporting"
                    @click="onExport"
                    >Export</el-button
                >
            </div>
            <v-custom-date-range-picker
                @dateRange="
                    (v) => {
                        dateRange = v;
                    }
                "
            ></v-custom-date-range-picker>
        </el-menu>

        <div class="p-30" v-if="definition">
            <el-card shadow="none" class="mb-20 report__filter">
                <div class="title mb-5">Filter</div>
                <div class="flex">
                    <div class="mr-4 w-1/4">
                        <div class="report__filter-label">Coupon</div>
                        <el-select
                            v-model="filterResults.coupon"
                            placeholder="Select"
                        >
                            <el-option
                                v-for="item in filterOptions.coupon"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="mr-4 w-1/4">
                        <div class="report__filter-label">Customer group</div>
                        <el-select
                            v-model="filterResults.customerGroup"
                            placeholder="Select"
                        >
                            <el-option
                                v-for="item in filterOptions.customerGroup"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="mr-4 w-1/4">
                        <div class="report__filter-label">Gender</div>
                        <el-select
                            v-model="filterResults.gender"
                            placeholder="Select"
                        >
                            <el-option
                                v-for="item in filterOptions.gender"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="w-1/4">
                        <div class="report__filter-label">Origin</div>
                        <el-select
                            v-model="filterResults.origin"
                            placeholder="Select"
                        >
                            <el-option
                                v-for="item in filterOptions.origin"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="flex mt-4">
                    <div class="mr-4 w-1/4">
                        <div class="report__filter-label">Categories</div>
                        <el-select
                            v-model="filterResults.categories"
                            placeholder="Select"
                            multiple
                        >
                            <el-option
                                v-for="item in filterOptions.categories"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="mr-4 w-1/4">
                        <div class="report__filter-label">Payment</div>
                        <el-select
                            v-model="filterResults.payment"
                            placeholder="Select"
                            multiple
                        >
                            <el-option
                                v-for="item in filterOptions.payment"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="mr-4 w-1/4">
                        <div class="report__filter-label">Products</div>
                        <el-select
                            v-model="filterResults.products"
                            placeholder="Search"
                            multiple
                            filterable
                            remote
                            :remote-method="getProductsBySearch"
                            no-data-text="No search result found"
                            no-match-text="No search result found"
                        >
                            <el-option
                                v-for="item in filterOptions.products"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="w-1/4">
                        <div class="report__filter-label">Status</div>
                        <el-select
                            v-model="filterResults.status"
                            placeholder="Select"
                            multiple
                        >
                            <el-option
                                v-for="item in filterOptions.status"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </el-card>
            <el-row type="flex" align="middle" justify="end">
                <el-col :sm="24" :md="12" class="mb-20">
                    <el-button @click="onBack">Back to overview</el-button>
                </el-col>
                <el-col :sm="24" :md="12" class="mb-20">
                    <div
                        class="flex gap justify-end"
                        v-if="reportData && reportData.length > 0"
                    >
                        <el-select
                            v-model="selectedFilter"
                            placeholder="Select"
                            @change="filterReport"
                        >
                            <el-option
                                v-for="item in reportFilterOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                        <el-radio-group
                            v-model="groupBy"
                            v-if="definition.filterTabs"
                        >
                            <el-radio-button
                                v-for="el in definition.filterTabs"
                                v-bind:key="el"
                                v-bind:label="el"
                                >{{ el }}</el-radio-button
                            >
                        </el-radio-group>
                    </div>
                </el-col>
            </el-row>

            <el-card
                shadow="none"
                class="mb-20"
                v-if="
                    definition.table &&
                    reportData &&
                    reportData.length > 0 &&
                    chartData.values &&
                    !chartData.values.every((e) => e === 0)
                "
            >
                <chart-bar-and-line
                    v-if="definition.chart === 'BAR_AND_LINE'"
                    v-bind:data="chartData"
                ></chart-bar-and-line>
                <chart-pie
                    v-else-if="definition.chart === 'PIE'"
                    v-bind:data="chartData"
                ></chart-pie>
            </el-card>

            <el-table
                v-if="definition.table && reportData"
                :data="reportData"
                class="w-full"
                stripe
            >
                <el-table-column
                    v-for="(def, index) in definition.table"
                    v-bind:key="def.key"
                    v-bind:label="def.label"
                    v-bind:prop="def.key"
                    sortable
                >
                    <template slot-scope="scope">
                        <div
                            class="flex items-center"
                            v-if="
                                selectedReport === 'best_seller' &&
                                reportData.length > 20
                                    ? scope.$index !== reportData.length - 1
                                    : true
                            "
                        >
                            <span
                                v-if="
                                    index === 0 &&
                                    reportData.length <= chartColors.length
                                "
                                :style="{
                                    background: chartColors[scope.$index],
                                }"
                                class="chart-color-indicator"
                            ></span>
                            <span v-if="def.format === 'DATE'">{{
                                scope.row[scope.column.property] | date
                            }}</span>
                            <span v-else-if="def.format === 'CURRENCY'">{{
                                scope.row[scope.column.property]
                                    | currency(
                                        scope.row['currency']
                                            ? scope.row['currency']
                                            : defaultCurrency
                                    )
                            }}</span>
                            <span v-else>{{
                                scope.row[scope.column.property]
                            }}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import api from '../libs/api';
import download from '../libs/download';
import ChartBarAndLine from './ChartBarAndLine';
import chartColors from './../libs/chartColors.definition.js';
import chartData from './../libs/chartData.helper.js';
import ChartPie from './ChartPie';
import moment from 'moment';
import reportDefinition from './../libs/report.definition.js';

export default {
    name: 'reports',
    props: ['config', 'rootConfig'],
    components: { ChartBarAndLine, ChartPie },

    data() {
        return {
            reportData: [],
            loading: false,
            exporting: false,
            dateRange: [],
            title: '',
            definition: null,
            options: [],
            selectedReport: '',
            reportFilterOptions: [],
            selectedFilter: '',
            chartData: {},
            chartColors: [],
            groupBy: 'day',
            filterOptions: {
                products: [],
                categories: [],
                origin: [],
                customerGroup: [],
                gender: [
                    { label: 'All', value: 'All' },
                    { label: 'Male', value: false },
                    { label: 'Female', value: true },
                ],
                status: [],
                payment: [],
                coupon: [
                    { label: 'All', value: 'All' },
                    { label: 'With coupon', value: true },
                    { label: 'Without coupon', value: false },
                ],
            },
            filterOptionsDefinition: [
                { name: 'categories', endpoint: 'get_categories_filter' },
                {
                    name: 'origin',
                    endpoint: 'get_filter_origin_list',
                },
                {
                    name: 'customerGroup',
                    endpoint: 'get_customer_groups_filter',
                },
                { name: 'status', endpoint: 'get_statuses_filter' },
                { name: 'payment', endpoint: 'get_payments_filter' },
            ],
            filterResults: {
                products: [],
                categories: [],
                origin: 'All',
                customerGroup: 'All',
                gender: 'All',
                status: [],
                payment: [],
                coupon: 'All',
            },
            defaultCurrency: null,
        };
    },

    mounted() {
        this.chartColors = chartColors;
        this.loadFilterOptions();
        this.getDefaultCurrency();
        this.init();
    },

    watch: {
        dateRange() {
            this.startLoading();
        },

        groupBy() {
            this.startLoading();
        },

        filterResults: {
            handler() {
                this.startLoading();
            },
            deep: true,
        },
    },

    methods: {
        getDefaultCurrency() {
            this.loading = true;
            const apiResource = this.$resource(
                this.rootConfig.endPoint + '/settings',
                {},
                {},
                {
                    headers: this.rootConfig.headers,
                }
            );
            apiResource
                .get({
                    code: 'general_setting',
                    setting_key: 'default_currency',
                })
                .then((res) => {
                    if (res.body.length > 0) {
                        this.defaultCurrency = res.body[0].setting;
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                    api.errorHandler;
                });
        },
        init() {
            this.selectedReport = this.config.id;
            this.definition = reportDefinition[this.selectedReport];

            if (this.definition) {
                this.title = this.definition.title || 'Detail';
                this.reportFilterOptions = this.definition.table
                    .filter((e) => e.filterable)
                    .map((e) => {
                        return { value: e.key, label: e.label };
                    });
                this.selectedFilter =
                    this.definition.filterPreselect ||
                    this.reportFilterOptions[0].value;

                if (this.dateRange && this.dateRange.length === 2) {
                    this.reportData = [];
                    this.loadOverview();
                }
            }

            this.options = Object.keys(reportDefinition).map((key) => {
                return { value: key, label: reportDefinition[key].title };
            });
        },

        loadOverview() {
            this.loading = true;
            const startDate = moment(this.dateRange[0]).toISOString(true);
            const endDate = moment(this.dateRange[1]).toISOString(true);

            const apiResource = this.$resource(
                this.rootConfig.endPoint + '/reports/' + this.definition.api,
                {},
                {},
                {
                    headers: this.rootConfig.headers,
                    params: {
                        start_date: startDate,
                        end_date: endDate,
                        group_by: this.groupBy,
                        filter_products: this.filterResults.products,
                        filter_categories: this.filterResults.categories,
                        filter_origin: this.filterResults.origin,
                        filter_group: this.filterResults.customerGroup,
                        filter_gender: this.filterResults.gender,
                        filter_status: this.filterResults.status,
                        filter_payment: this.filterResults.payment,
                        filter_coupons: this.filterResults.coupon,
                    },
                }
            );

            apiResource
                .get()
                .then(this.setReportData)
                .catch(() => {
                    this.loading = false;
                    api.errorHandler;
                });
        },

        setReportData(res) {
            let reportData = res.body;
            reportData = reportData.map((e) => {
                if (e.date && this.groupBy) {
                    switch (this.groupBy) {
                        case 'month':
                            e.date = moment(String(e.date)).format('M.YYYY');
                            break;
                        case 'year':
                            e.date = moment(String(e.date)).format('YYYY');
                            break;
                        default:
                            e.date = moment(String(e.date)).format('D.M.YYYY');
                    }
                }
                return e;
            });
            this.reportData = reportData;
            this.filterReport(this.selectedFilter);
            this.loading = false;
        },

        onBack() {
            this.$router.push({ name: 'home' });
        },

        onExport() {
            this.exporting = true;

            const startDate = moment(this.dateRange[0]).toISOString(true);
            const endDate = moment(this.dateRange[1]).toISOString(true);

            const apiResource = this.$resource(
                this.rootConfig.endPoint + '/reports/' + this.definition.api,
                {},
                {},
                {
                    headers: this.rootConfig.headers,
                    responseType: 'blob',
                    params: {
                        start_date: startDate,
                        end_date: endDate,
                        group_by: this.groupBy,
                        filter_products: this.filterResults.products,
                        filter_categories: this.filterResults.categories,
                        filter_origin: this.filterResults.origin,
                        filter_group: this.filterResults.customerGroup,
                        filter_gender: this.filterResults.gender,
                        filter_status: this.filterResults.status,
                        filter_payment: this.filterResults.payment,
                        filter_coupons: this.filterResults.coupon,
                        as_excel: true,
                    },
                }
            );

            apiResource
                .get()
                .then((res) => {
                    download(
                        res.data,
                        'statistics.xls',
                        'application/vnd.ms-excel'
                    );
                    this.exporting = false;
                })
                .catch(() => {
                    this.exporting = false;
                    api.errorHandler;
                });
        },

        navigateTo(id) {
            this.config.id = id;
            this.$router.push({
                name: 'admin',
                params: { model: 'report', id, action: 'all' },
            });
            this.init();
        },

        filterReport(type) {
            let data = this.reportData;
            if (this.selectedReport === 'best_seller') {
                data = this.reportData.sort((a, b) => {
                    if (a.sku && a.sku === '000000') {
                        return 1;
                    }
                    return b[type] - a[type];
                });
            }
            this.chartData = chartData(
                type,
                data,
                this.definition,
                this.selectedReport,
                this.reportData[0].currency
                    ? this.reportData[0].currency
                    : this.defaultCurrency
            );
        },

        startLoading() {
            if (this.definition.api) {
                if (this.dateRange && this.dateRange.length === 2) {
                    this.loadOverview();
                }
            } else {
                this.loading = false;
            }
        },

        getProductsBySearch(query) {
            const apiResource = this.$resource(
                this.rootConfig.endPoint + '/products',
                {},
                {},
                {
                    headers: this.rootConfig.headers,
                }
            );

            if (query && query.length > 2) {
                this.loading = true;
                apiResource
                    .get({ term: query })
                    .then((res) => {
                        this.loading = false;
                        const mappedData = [];
                        res.data.forEach((entry) => {
                            mappedData.push({
                                label: entry.name,
                                value: entry.sku,
                            });
                        });
                        this.filterOptions.products = mappedData;
                    })
                    .catch(() => {
                        this.loading = false;
                        api.errorHandler;
                    });
            } else {
                this.filterOptions.products = [];
            }
        },

        loadFilterOptions() {
            this.loading = true;

            this.filterOptionsDefinition.forEach((filterOption) => {
                const apiResource = this.$resource(
                    this.rootConfig.endPoint +
                        '/reports/' +
                        filterOption.endpoint,
                    {},
                    {},
                    { headers: this.rootConfig.headers }
                );

                apiResource
                    .get()
                    .then((res) => {
                        const mappedData = [];
                        if (
                            filterOption.name === 'customerGroup' ||
                            filterOption.name === 'origin'
                        ) {
                            mappedData.push({ label: 'All', value: 'All' });
                        }
                        res.data.forEach((entry) => {
                            if (filterOption.name !== 'categories') {
                                mappedData.push({
                                    label: entry
                                        ? entry[0].toUpperCase() +
                                          entry.slice(1).toLowerCase()
                                        : 'Undefined',
                                    value: entry,
                                });
                            } else {
                                mappedData.push({
                                    label: entry.name,
                                    value: entry.id,
                                });
                            }
                        });
                        this.filterOptions[`${filterOption.name}`] = mappedData;
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                        api.errorHandler;
                    });
            });
        },
    },
};
</script>

<style scoped>
.report__filter .el-select {
    display: block;
}

.report__filter .report__filter-label {
    margin-bottom: 0.25rem;
    font-size: 0.875rem;
}

.w-full {
    width: 100%;
}

.h-full {
    height: 100%;
}

.h-60 {
    height: 60px;
}

.p-30 {
    padding: 30px;
}

.px-30 {
    padding-left: 30px;
    padding-right: 30px;
}

.mb-20 {
    margin-bottom: 20px;
}

.title {
    font-size: 1.2rem;
    font-weight: normal;
    margin-right: auto;
}

.container {
    margin-bottom: 40px;
}

.flex {
    display: flex;
}

.flex-column {
    flex-direction: column;
}

.flex-column .el-button {
    margin-left: 0 !important;
}

.grow {
    flex-grow: 1;
}

.gap {
    gap: 20px;
}

.items-center {
    align-items: center;
}

.justify-end {
    justify-content: end;
}

.chart-color-indicator {
    height: 20px;
    width: 20px;
    display: inline-block;
    border-radius: 2px;
    margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// ReportDetail.vue?129907d6